/**
 * Ticket numbers come in two shapes: Helix-issued ones already carry their
 * document prefix (TKT-SA-2008), legacy SalesTracker ones are bare (61781).
 * Never concatenate "TKT-" by hand — use this.
 */
export function formatTicketNumber(number: string | number | null | undefined): string {
  if (number == null) return "";
  const n = String(number).trim();
  return /^TKT-/i.test(n) ? n : "TKT-" + n;
}
